import { DataModel } from "common/models/utility-models/base-model";

export class BranchCategoryModel extends DataModel {
    branchCatName: string = null;
}